// extracted by mini-css-extract-plugin
export var closeButton = "_1e-3";
export var header = "_1e-0";
export var link = "_1e-1";
export var retryButton = "_1e-2";